import { fetchData } from 'modules/Axios';
import { setAccountFromBrandSwitcher, setBrandFromBrandSwitcher, setBrandsFromBrandSwitcher } from 'modules/App';
import { showToast } from 'modules/Notifications';

const defaultState = {
  data: [],
  account: {},
  brand: {},
};

export const SET_ACCOUNT_AND_BRAND = 'SET_ACCOUNT_AND_BRAND';
export const setAccountAndBrand = (account, brand, routerPush) => {
  return async (dispatch, getState) => {
    const { data } = getState().brandSwitcher;
    await Promise.all([
      dispatch(setAccountFromBrandSwitcher(account)),
      dispatch(setBrandFromBrandSwitcher(brand)),
      dispatch(setBrandsFromBrandSwitcher(data, account.id))
    ]);
    dispatch({ type: SET_ACCOUNT_AND_BRAND, payload: { account, brand } });
    return routerPush(`/${account.sid}/${brand.sid}`);
  };
};

export const RESET_ROUTE_DATA = 'RESET_ROUTE_DATA';
export const resetRouteData = () => ({
  type: RESET_ROUTE_DATA,
});

export const RESET_DATA = 'RESET_DATA';
export const resetData = () => ({
  type: RESET_DATA,
});

export const RECEIVE_DATA = 'RECEIVE_DATA';
export const receiveData = data => ({
  type: RECEIVE_DATA,
  payload: data,
});

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const buildDataStructure = () => {
  return async (dispatch, getState) => {
    try {
      // fetch all pages of data at once (only 1 page is expected for the forseeable future)
      let last = false;
      let data = [];
      let currentPage = 0;

      while (!last) {
        const URL = `/accounts/brands?size=2000&page=${currentPage}`;
        // eslint-disable-next-line no-await-in-loop
        const currentGetDataRequest = await dispatch(fetchData(URL));
        data = data.concat(currentGetDataRequest.content);
        last = currentGetDataRequest.last;
        currentPage += 1;
      }

      dispatch(receiveData({
        data
      }));
    } catch (e) {
      console.error('API Call to /accounts/brands failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving accounts list. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      dispatch(receiveData({
        data: []
      }));
    }
  };
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_ACCOUNT_AND_BRAND:
      return { ...state, account: action.payload.account, brand: action.payload.brand };
    case RECEIVE_DATA:
      return {
        ...state,
        data: action.payload.data
      };
    case RESET_DATA:
      return {
        ...state,
        data: defaultState.data,
      };
    case RESET_ROUTE_DATA:
      return { ...defaultState };
    default:
      return state;
  }
}
